export default "__VITE_ASSET__7a2999e3__"